import React from 'react'
import styled from 'styled-components'
import { breakpoint } from 'src/theme/grid'
import { TableHeader, TableRow } from 'src/features/myOffers/components/atoms'
import { PrivateLabel } from 'src/features/offers/components/atoms'

export const GeneralOfferBadges = ({ offer, showPrivate = true }) =>
  showPrivate && offer.isPrivate ? <PrivateLabel /> : null

export const GeneralTableRowOngoing = styled(TableRow)`
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.5fr 1fr 1fr;
  grid-template-areas:
    'index index date date'
    'locationFrom locationFrom locationTo locationTo'
    'container container handler handler';

  ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 3fr 2fr;
     grid-template-areas:
    'select index reservations locationFrom locationTo container handler date'
  `}

  &:hover {
    ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 2fr 3fr;
    `}
  }
`

export const GeneralTableHeaderOngoing = styled(TableHeader)`
  &:hover {
    ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 3fr 2fr;
    `}
  }

  ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 3fr 2fr;
  `}
`

export const GeneralTableRowFinished = styled(TableRow)`
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.5fr 1fr 1fr;
  grid-template-areas:
    'index index date date'
    'locationFrom locationFrom locationTo locationTo'
    'container container handler handler';

  ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 3fr 2fr;
     grid-template-areas:
    'status index reservations locationFrom locationTo container handler date'
  `}

  &:hover {
    ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 2fr 3fr;
    `}
  }
`

export const GeneralTableHeaderFinished = styled(TableHeader)`
  &:hover {
    ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 3fr 2fr;
    `}
  }

  ${breakpoint.m`
     grid-template-columns: minmax(35px, 0.8fr) 2fr 2.3fr 3fr 3fr 2fr 3fr 2fr;
     grid-template-areas:
    'status index reservations locationFrom locationTo container handler date'
  `}
`
